let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f3VhN")).then(() => parcelRequire('h5JHV'));